/**
 * STICKER STYLES ENGINE V5 - AVISOCAR
 * ====================================
 * Enhanced style customization engine with:
 * - Undo/Redo history support
 * - More gradient presets
 * - Better icon packs by category
 * - Auto-fit text sizing
 * - Enhanced color palettes
 */

// Preset gradient backgrounds (12 + 6 new)
export const GRADIENT_PRESETS = [
  { id: "sunset", name: "Atardecer", colors: ["#F97316", "#DC2626"], angle: 135 },
  { id: "ocean", name: "Océano", colors: ["#0EA5E9", "#38BDF8"], angle: 135 },
  { id: "forest", name: "Bosque", colors: ["#10B981", "#6EE7B7"], angle: 135 },
  { id: "purple", name: "Violeta", colors: ["#8B5CF6", "#C4B5FD"], angle: 135 },
  { id: "fire", name: "Fuego", colors: ["#EF4444", "#F97316"], angle: 180 },
  { id: "candy", name: "Dulce", colors: ["#EC4899", "#FBCFE8"], angle: 135 },
  { id: "midnight", name: "Medianoche", colors: ["#0F172A", "#1E293B"], angle: 180 },
  { id: "gold", name: "Dorado", colors: ["#F59E0B", "#FDE68A"], angle: 135 },
  { id: "arctic", name: "Ártico", colors: ["#06B6D4", "#A5F3FC"], angle: 135 },
  { id: "lime", name: "Lima", colors: ["#84CC16", "#D9F99D"], angle: 135 },
  { id: "peru", name: "Perú", colors: ["#DC2626", "#FFFFFF"], angle: 180 },
  { id: "rainbow", name: "Arcoíris", colors: ["#EC4899", "#8B5CF6", "#06B6D4"], angle: 90 },
  // V5: New premium gradients
  { id: "rose_gold", name: "Rosa Dorado", colors: ["#F43F5E", "#FB923C"], angle: 135 },
  { id: "mint", name: "Menta", colors: ["#10B981", "#A7F3D0"], angle: 180 },
  { id: "royal", name: "Real", colors: ["#4338CA", "#6366F1"], angle: 135 },
  { id: "coral", name: "Coral", colors: ["#FB7185", "#FDA4AF"], angle: 180 },
  { id: "charcoal", name: "Carbón", colors: ["#1F2937", "#374151"], angle: 180 },
  { id: "aqua", name: "Aqua", colors: ["#0891B2", "#22D3EE"], angle: 135 },
];

// Text color presets (9 + 3 new)
export const TEXT_COLORS = [
  { id: "white", name: "Blanco", value: "#FFFFFF" },
  { id: "black", name: "Negro", value: "#0F172A" },
  { id: "slate", name: "Gris", value: "#64748B" },
  { id: "emerald", name: "Verde", value: "#10B981" },
  { id: "blue", name: "Azul", value: "#3B82F6" },
  { id: "red", name: "Rojo", value: "#EF4444" },
  { id: "gold", name: "Dorado", value: "#F59E0B" },
  { id: "purple", name: "Morado", value: "#8B5CF6" },
  { id: "pink", name: "Rosa", value: "#EC4899" },
  // V5: Additional colors
  { id: "cyan", name: "Cian", value: "#06B6D4" },
  { id: "lime", name: "Lima", value: "#84CC16" },
  { id: "orange", name: "Naranja", value: "#F97316" },
];

// V5: Icon packs organized by category
export const ICON_PACKS = {
  vehiculos: [
    { id: "car", emoji: "🚗", name: "Auto" },
    { id: "car_side", emoji: "🚙", name: "SUV" },
    { id: "motorcycle", emoji: "🏍️", name: "Moto" },
    { id: "truck", emoji: "🚚", name: "Camión" },
    { id: "tow", emoji: "🚛", name: "Grúa" },
  ],
  emergencia: [
    { id: "lights", emoji: "🚨", name: "Alerta" },
    { id: "emergency", emoji: "🆘", name: "SOS" },
    { id: "warning", emoji: "⚠️", name: "Advertencia" },
    { id: "fire", emoji: "🔥", name: "Fuego" },
    { id: "ambulance", emoji: "🚑", name: "Ambulancia" },
  ],
  contacto: [
    { id: "phone", emoji: "📱", name: "Teléfono" },
    { id: "lock", emoji: "🔒", name: "Privado" },
    { id: "bell", emoji: "🔔", name: "Notificar" },
    { id: "message", emoji: "💬", name: "Mensaje" },
    { id: "qr", emoji: "📲", name: "Escanear" },
  ],
  familia: [
    { id: "child", emoji: "🧒", name: "Niño" },
    { id: "baby", emoji: "👶", name: "Bebé" },
    { id: "family", emoji: "👨‍👩‍👧", name: "Familia" },
    { id: "heart", emoji: "❤️", name: "Amor" },
    { id: "home", emoji: "🏠", name: "Casa" },
  ],
  mascotas: [
    { id: "pet", emoji: "🐾", name: "Huella" },
    { id: "dog", emoji: "🐕", name: "Perro" },
    { id: "cat", emoji: "🐱", name: "Gato" },
    { id: "bone", emoji: "🦴", name: "Hueso" },
    { id: "collar", emoji: "🦺", name: "Collar" },
  ],
  viaje: [
    { id: "luggage", emoji: "🧳", name: "Maleta" },
    { id: "plane", emoji: "✈️", name: "Avión" },
    { id: "map", emoji: "🗺️", name: "Mapa" },
    { id: "globe", emoji: "🌎", name: "Mundo" },
    { id: "ticket", emoji: "🎫", name: "Ticket" },
  ],
};

// Flattened icon toggles for backward compatibility
export const ICON_TOGGLES = [
  { id: "car", emoji: "🚗", name: "Auto", defaultOn: true },
  { id: "lights", emoji: "🚨", name: "Luces", defaultOn: false },
  { id: "pet", emoji: "🐾", name: "Mascota", defaultOn: false },
  { id: "luggage", emoji: "🧳", name: "Maleta", defaultOn: false },
  { id: "child", emoji: "🧒", name: "Niño", defaultOn: true },
  { id: "emergency", emoji: "🆘", name: "Emergencia", defaultOn: false },
  { id: "phone", emoji: "📱", name: "Teléfono", defaultOn: true },
  { id: "lock", emoji: "🔒", name: "Privado", defaultOn: true },
];

// Sticker styles (design modes)
export const STICKER_STYLES = [
  { id: "minimal", name: "Minimal", description: "Limpio y elegante" },
  { id: "comic", name: "Comic", description: "Divertido y colorido" },
  { id: "premium_latam", name: "Premium LATAM", description: "Estilo peruano" },
  { id: "safety_warning", name: "Safety Warning", description: "Alerta de seguridad" },
  { id: "cute_kids", name: "Cute Kids", description: "Para niños" },
  { id: "travel_tag", name: "Travel Tag", description: "Etiqueta de viaje" },
  { id: "pet_friendly", name: "Pet Friendly", description: "Para mascotas" },
  { id: "professional", name: "Profesional", description: "Corporativo" },
];

// V5: Text size presets for auto-fit
export const TEXT_SIZES = {
  title: { small: 18, medium: 24, large: 32 },
  subtitle: { small: 12, medium: 14, large: 16 },
  slogan: { small: 14, medium: 18, large: 22 },
  footer: { small: 8, medium: 9, large: 10 },
};

// V5: Footer content (FIXED - NOT EDITABLE)
export const STICKER_FOOTER = {
  line1: "AvisoCar.com",
  line2: "Escanea el QR y contacta al dueño de forma anónima y segura",
};

// CORTE 4-C 2.2 — texto impreso del sticker por idioma del dueño
export const STICKER_FOOTER_LINE2_I18N = {
  es: "Escanea el QR y contacta al dueño de forma anónima y segura",
  en: "Scan the QR and contact the owner anonymously and securely",
  pt: "Escaneie o QR e contate o dono de forma anônima e segura",
  fr: "Scannez le QR et contactez le propriétaire de façon anonyme et sécurisée",
};

export function getStickerFooter(lang) {
  return {
    line1: STICKER_FOOTER.line1,
    line2: STICKER_FOOTER_LINE2_I18N[lang] || STICKER_FOOTER_LINE2_I18N.es,
  };
}

// Default style state
export const DEFAULT_STYLE_STATE = {
  backgroundGradient: GRADIENT_PRESETS[0],
  primaryTextColor: TEXT_COLORS[0],
  secondaryTextColor: TEXT_COLORS[2],
  borderRadius: 24,
  shadowIntensity: "medium", // low, medium, high
  glowEnabled: false,
  frameEnabled: true,
  selectedStyle: "minimal",
  activeIcons: ["car"],
  characterId: null,
  characterEnabled: false,
  // Editable text fields
  title: "",
  subtitle: "",
  slogan: "",
  customEmoji: "",
  // V5: Text sizing
  titleSize: "L",
  subtitleSize: "M",
  sloganSize: "M",
  footerSize: "medium",
  textAlign: "center", // left, center, right
  // V6.0: Drag-based positioning (no fixed positions)
  showIcons: true,
  layoutOffsets: {
    icons: { x: 0, y: 0 },
    emoji: { x: 0, y: 0 }
  }
};

// V5: History manager for Undo/Redo
const MAX_HISTORY_SIZE = 50;

export class StyleHistory {
  constructor(initialState) {
    this.history = [{ ...initialState }];
    this.currentIndex = 0;
  }

  push(state) {
    // Remove any future states if we're not at the end
    this.history = this.history.slice(0, this.currentIndex + 1);
    
    // Add new state
    this.history.push({ ...state });
    
    // Trim history if too large
    if (this.history.length > MAX_HISTORY_SIZE) {
      this.history = this.history.slice(this.history.length - MAX_HISTORY_SIZE);
      this.currentIndex = this.history.length - 1;
    } else {
      this.currentIndex++;
    }
  }

  undo() {
    if (this.canUndo()) {
      this.currentIndex--;
      return { ...this.history[this.currentIndex] };
    }
    return null;
  }

  redo() {
    if (this.canRedo()) {
      this.currentIndex++;
      return { ...this.history[this.currentIndex] };
    }
    return null;
  }

  canUndo() {
    return this.currentIndex > 0;
  }

  canRedo() {
    return this.currentIndex < this.history.length - 1;
  }

  getCurrent() {
    return { ...this.history[this.currentIndex] };
  }

  reset(state) {
    this.history = [{ ...state }];
    this.currentIndex = 0;
  }
}

/**
 * Style update function - merges new values with current state
 */
export const updateStyle = (currentState, updates) => {
  return {
    ...currentState,
    ...updates,
  };
};

/**
 * Generate CSS gradient string from preset
 */
export const generateGradientCSS = (preset) => {
  if (!preset || !preset.colors) return "linear-gradient(135deg, #10B981 0%, #6EE7B7 100%)";
  
  const { colors, angle = 135 } = preset;
  
  if (colors.length === 2) {
    return `linear-gradient(${angle}deg, ${colors[0]} 0%, ${colors[1]} 100%)`;
  } else if (colors.length === 3) {
    return `linear-gradient(${angle}deg, ${colors[0]} 0%, ${colors[1]} 50%, ${colors[2]} 100%)`;
  }
  
  return `linear-gradient(${angle}deg, ${colors.join(", ")})`;
};

/**
 * Get shadow style based on intensity
 */
export const getShadowStyle = (intensity) => {
  switch (intensity) {
    case "low":
      return "0 4px 12px rgba(0,0,0,0.1)";
    case "high":
      return "0 20px 60px rgba(0,0,0,0.3)";
    case "medium":
    default:
      return "0 12px 40px rgba(0,0,0,0.2)";
  }
};

/**
 * V5: Calculate auto-fit font size based on text length
 */
export const calculateAutoFitSize = (text, type, maxWidth = 280) => {
  if (!text) return TEXT_SIZES[type]?.medium || 16;
  
  const baseSize = TEXT_SIZES[type]?.large || 24;
  const minSize = TEXT_SIZES[type]?.small || 12;
  
  // Approximate character width ratio
  const avgCharWidth = baseSize * 0.5;
  const estimatedWidth = text.length * avgCharWidth;
  
  if (estimatedWidth <= maxWidth) {
    return baseSize;
  }
  
  // Scale down proportionally
  const scaleFactor = maxWidth / estimatedWidth;
  const newSize = Math.max(minSize, Math.floor(baseSize * scaleFactor));
  
  return newSize;
};

/**
 * Convert style state to canvas rendering options
 */
export const styleStateToCanvasOptions = (state) => {
  return {
    background: {
      gradient: state.backgroundGradient,
      css: generateGradientCSS(state.backgroundGradient),
    },
    text: {
      primary: state.primaryTextColor.value,
      secondary: state.secondaryTextColor.value,
      align: state.textAlign,
    },
    frame: {
      borderRadius: state.borderRadius,
      shadow: getShadowStyle(state.shadowIntensity),
      glow: state.glowEnabled,
      enabled: state.frameEnabled,
    },
    character: {
      id: state.characterId,
      enabled: state.characterEnabled,
    },
    icons: {
      active: state.activeIcons,
      position: state.iconPosition,
      show: state.showIcons,
    },
    style: state.selectedStyle,
    content: {
      title: state.title,
      subtitle: state.subtitle,
      slogan: state.slogan,
      emoji: state.customEmoji,
    },
    sizing: {
      title: state.titleSize,
      subtitle: state.subtitleSize,
      slogan: state.sloganSize,
      footer: state.footerSize,
    },
  };
};

export default {
  GRADIENT_PRESETS,
  TEXT_COLORS,
  ICON_TOGGLES,
  ICON_PACKS,
  STICKER_STYLES,
  TEXT_SIZES,
  STICKER_FOOTER,
  DEFAULT_STYLE_STATE,
  StyleHistory,
  updateStyle,
  generateGradientCSS,
  getShadowStyle,
  calculateAutoFitSize,
  styleStateToCanvasOptions,
};
